import React, { useContext, useState } from 'react';
import { withStyles } from '@material-ui/core';
import DataContext from '../../data/DataContext';
import ChatbotLogo from '../../../asset/img/logo_chatbot.webp';
import ChatbotLogo2x from '../../../asset/img/logo_chatbot@2x.webp';
import ChatbotLogo3x from '../../../asset/img/logo_chatbot@3x.webp';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    background: '#f0ece4',
    // minHeight:"29.375rem",
    // height:"29.375rem",
    zIndex: 10,
  },
  welcomeArea: {
    height: '7.625rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  welcomeMsg: {
    padding: '2rem 0rem 0rem 1.25rem',
  },
  welcomeMsg1: {
    fontSize: theme.font.size20,
    fontWeight: 600,
  },
  welcomeMsg2: {
    fontSize: theme.font.size13,
  },
  chatbotLogo: {
    minWidth: '7.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0.75rem 0 0 1.25rem',
  },
});

function WELCOME(props) {
  const { classes, data } = props;
  // const context = useContext(DataContext);
  // const [selectedIndex, setSelectedIndex] = useState(1);
  const userName = data.user_name || '고객';
  return (
    <div className={classes.root}>
      <div className={classes.welcomeArea}>
        <div className={classes.welcomeMsg}>
          <div className={classes.welcomeMsg1}>안녕하세요 {userName}님!</div>
          <div className={classes.welcomeMsg2}>LG전자 상담 챗봇입니다.</div>
        </div>
        <div className={classes.chatbotLogo}>
          <img
            src={ChatbotLogo}
            srcSet={`${ChatbotLogo2x} 2x, ${ChatbotLogo3x} 3x`}
            alt="Hello"
          />
        </div>
      </div>
    </div>
  );
}
export default withStyles(styles)(WELCOME);
